import {
  GET_ARTICLES,
  UPDATE_ARTICLES,
  GET_CARS,
  GET_SITES,
  UPDATE_SITES,
  UPDATE_CARS,
  UPDATE_SITE_FILTERS,
  UPDATE_CAR_FILTERS,
  UPDATE_ARTICLE_FILTERS,
} from '../actions/types';

export const getApiEndpoint = (filterType) => {
  switch (filterType) {
    case 'Article':
      return '/apicommerce/articles/SearchArticlesWithFilters';

    case 'Site':
      return '/apicommerce/BavariaNo/SearchSitesWithFilters';

    default:
      return '/apicommerce/BavariaNo/SearchCarsWithFilters';
  }
};

export const getItemsKey = (filterType) => {
  switch (filterType) {
    case 'Article':
      return 'articles';

    case 'Site':
      return 'sites';

    default:
      return 'cars';
  }
};

export const getItemFiltersKey = (filterType) => {
  switch (filterType) {
    case 'Article':
      return 'articleFilters';

    case 'Site':
      return 'siteFilters';

    default:
      return 'carFilters';
  }
};

export const getDefItemFiltersKey = (filterType) => {
  switch (filterType) {
    case 'Article':
      return 'defArticleFilters';

    case 'Site':
      return 'defSiteFilters';

    default:
      return 'defCarFilters';
  }
};

export const getUpdateItemFiltersAction = (filterType) => {
  switch (filterType) {
    case 'Article':
      return UPDATE_ARTICLE_FILTERS;

    case 'Site':
      return UPDATE_SITE_FILTERS;

    default:
      return UPDATE_CAR_FILTERS;
  }
};

export const getCurrentItems = (filterActions, filterType) => {
  let action;

  switch (filterType) {
    case 'Article':
      action = GET_ARTICLES;
      break;

    case 'Site':
      action = GET_SITES;
      break;

    default:
      action = GET_CARS;
      break;
  }

  return filterActions(action, null, { filterType });
};

export const updateItems = (filterActions, filterType, value) => {
  let action;

  switch (filterType) {
    case 'Article':
      action = UPDATE_ARTICLES;
      break;

    case 'Site':
      action = UPDATE_SITES;
      break;

    default:
      action = UPDATE_CARS;
      break;
  }

  return filterActions(action, value, { filterType });
};
